import {format} from 'date-fns'
import './AppointmentListItem.css'

interface AppointmentListItemProps {
  title: string
  date: string
  meetingLocation?: string | null
  typeAppointment?: string | null
  leadName?: string | null
  onClick?: () => void
}

export const AppointmentListItem = ({
  title,
  date,
  meetingLocation,
  typeAppointment,
  leadName,
  onClick,
}: AppointmentListItemProps) => {
  const parsed = new Date(date)
  const timeLabel = Number.isNaN(parsed.getTime()) ? '' : format(parsed, 'hh:mm a')
  const dateLabel = Number.isNaN(parsed.getTime()) ? '' : format(parsed, 'MMM dd, yyyy')

  return (
    <div className='appointment-list-item' role={onClick ? 'button' : undefined} onClick={onClick}>
      <div className='appointment-list-icon'>
        <i className='bi bi-calendar-check'></i>
      </div>
      <div className='appointment-list-content'>
        <div className='appointment-list-title'>{title}</div>
        <div className='appointment-list-meta'>
          {timeLabel && (
            <span className='appointment-list-detail'>
              <i className='bi bi-clock'></i>
              {timeLabel}
            </span>
          )}
          {dateLabel && (
            <span className='appointment-list-detail'>
              <i className='bi bi-calendar-event'></i>
              {dateLabel}
            </span>
          )}
          {typeAppointment && (
            <span className='appointment-list-detail'>
              <i className='bi bi-tag'></i>
              {typeAppointment}
            </span>
          )}
          {meetingLocation && (
            <span className='appointment-list-detail'>
              <i className='bi bi-geo-alt'></i>
              {meetingLocation}
            </span>
          )}
          {leadName && (
            <span className='appointment-list-detail'>
              <i className='bi bi-person'></i>
              {leadName}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
